import { render } from "./ConnectFlowHistoryPage.vue?vue&type=template&id=b6985f98&ts=true"
import script from "./ConnectFlowHistoryPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectFlowHistoryPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/ConnectFlowHistoryPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6985f98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6985f98', __exports__)) {
    api.reload('b6985f98', __exports__)
  }
  
  module.hot.accept("./ConnectFlowHistoryPage.vue?vue&type=template&id=b6985f98&ts=true", () => {
    api.rerender('b6985f98', render)
  })

}


export default __exports__